export const companyInfo = {
  companyName: {
    title: '회사명',
    value: '텀블벅(주)',
  },
  address: {
    title: '주소',
    value: '서울 서초구 서초대로 398, 19층 (서초동, BNK디지털)',
  },
  ceo: {
    title: '대표',
    value: '김동환',
  },
  coporateRegistrationNumber: {
    title: '사업자등록번호',
    value: '105-87-52823',
  },
  onlineMarketingRegistrationNumber: {
    title: '통신판매업 신고번호',
    value: '2022-서울서초-0352',
  },
  mainPhoneNumber: {
    title: '대표번호',
    value: '02-6080-0760',
  },
  copyright: {
    value: `© ${new Date().getFullYear()} Tumblbug Inc.`,
  },
};
